import { render, staticRenderFns } from "./AdministrationGpec.vue?vue&type=template&id=7b2879f8&"
import script from "./AdministrationGpec.vue?vue&type=script&lang=js&"
export * from "./AdministrationGpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports